<template>
  <div class="wrap">
    <div class="header">
      <img src="../assets/images/header_img.png" />
    </div>
    <div class="content">
      <div class="service-panel">
        <div class="rocess-title mb48">
          <span>海那边·海外一站式服务</span>
        </div>
        <div class="switch-panel">
          <div class="switch-header flex flex-between">
            <div
              class="service-type"
              :class="[serviceType == 0 ? 'active' : 'border-left']"
              @click="setServiceType(0)"
            >
              出海前服务
            </div>
            <div
              class="service-type"
              :class="[serviceType == 1 ? 'active' : 'border-right']"
              @click="setServiceType(1)"
            >
              出海后当地服务
            </div>
          </div>
            <div
                class="service-content flex flex-wrap"
                v-show="serviceType == 0"
              >
                <div class="service-item">
                  <img src="../assets/images/s_item_01.png" />
                  <p>海外市场分析报告</p>
                </div>
                <div class="service-item">
                  <img src="../assets/images/s_item_02.png" />
                  <p>企业出海可行性报告</p>
                </div>
                <div class="service-item">
                  <img src="../assets/images/s_item_03.png" />
                  <p>海外企业注册</p>
                </div>
                <div class="service-item">
                  <img src="../assets/images/s_item_04.png" />
                  <p>海外银行账户开设</p>
                </div>
              </div>
              <div
            class="service-content flex flex-wrap"
            v-show="serviceType == 1"
          >
            <div class="service-item">
              <img src="../assets/images/s_item_05.png" />
              <p>签证办理</p>
            </div>
            <div class="service-item">
              <img src="../assets/images/s_item_06.png" />
              <p>接送机</p>
            </div>
            <div class="service-item">
              <img src="../assets/images/s_item_07.png" />
              <p>海外当地翻译服务</p>
            </div>
            <div class="service-item">
              <img src="../assets/images/s_item_08.png" />
              <p>海外当地考察陪同</p>
            </div>
            <template v-if="isShowAllItem">
              <div class="service-item">
                <img src="../assets/images/s_item_09.png" />
                <p>海外当地商标注册</p>
              </div>
              <div class="service-item">
                <img src="../assets/images/s_item_10.png" />
                <p>行业专业律师推荐和咨询</p>
              </div>
              <div class="service-item">
                <img src="../assets/images/s_item_11.png" />
                <p>知识产权保护咨询和代办</p>
              </div>
              <div class="service-item">
                <img src="../assets/images/s_item_12.png" />
                <p>各行业各类别行政许可证<br>咨询办理</p>
              </div>
              <div class="service-item">
                <img src="../assets/images/s_item_13.png" />
                <p>政府咨询对接和政策咨询</p>
              </div>
              <div class="service-item">
                <img src="../assets/images/s_item_14.png" />
                <p>商业资源接洽对接和商务拓展</p>
              </div>
              <div class="service-item">
                <img src="../assets/images/s_item_15.png" />
                <p>办公室、厂房、住宿等<br>租买咨询</p>
              </div>
              <div class="service-item">
                <img src="../assets/images/s_item_16.png" />
                <p>工业园、商务园入驻<br>咨询和商务对接</p>
              </div>
              <div class="service-item">
                <img src="../assets/images/s_item_17.png" />
                <p>员工招聘咨询和代招</p>
              </div>
              <div class="service-item">
                <img src="../assets/images/s_item_18.png" />
                <p>公司年审报税</p>
              </div>
            </template>
            <div
              class="more-button flex flex-middle flex-center"
              @click="isShowAllItem = !isShowAllItem"
            >
              <span>{{!isShowAllItem?'查看更多服务':'收起'}}</span>
              <i :class="[!isShowAllItem ? 'icon-arrow-down' : 'icon-arrow-up']"></i>
            </div>
          </div>
          </div>
        <div class="space-bg">
          <img src="../assets/images/space_bg.png" />
        </div>
      </div>
      <div class="company-panel">
        <div class="rocess-title mb66">
          <span>为什么选择海那边</span>
        </div>
        <div class="company-body">
          <div class="company-title">
            14年成立的国内首家互联网海外综合服务平台
          </div>
          <div class="office-desc">
            <img
              class="office-desc-maohao-left"
              src="../assets/images/maohao-left.png"
            />
            海那边
            <span>&nbsp;“出海企服”&nbsp;</span>总部位于深圳，在全球多地设立分公司和办公室。业务全方位涵盖海外移民、海外房产投资、海外财富咨询规划、海外企服等。
            <img
              class="office-desc-maohao-right"
              src="../assets/images/maohao-right.png"
            />
          </div>
          <div class="company-bg">海那边投资背景</div>
          <div class="company-money">海外服务行业唯一 一家获得顶级投资的企业，已完成知名投资人、投资机构多轮投资过亿元。</div>
          <div class="company-invest">
            <div class="invest-top flex flex-between">
              <img src="../assets/images/boss_01.png">
              <img src="../assets/images/boss_02.png">
              <img src="../assets/images/boss_03.png">
              <img src="../assets/images/boss_04.png">
              <img src="../assets/images/boss_05.png">
            </div>
            <div class="invest-bottom flex flex-wrap">
              <img src="../assets/images/invest_01.png">
              <img src="../assets/images/invest_02.png">
              <img src="../assets/images/invest_03.png">
              <img src="../assets/images/invest_04.png">
              <img src="../assets/images/invest_05.png">
            </div>
          </div>
          <div class="service-compare">
            <div class="compare-title flex flex-between mb10">
              <div class="light-panel">海那边海外企服</div>
              <div class="normal-panel">国内主要海外企服</div>
            </div>
            <div class="compare-item flex flex-between mb10">
              <div class="light-panel flex flex-start flex-middle">
                <div class="item-left">
                  <i class="icon-service-content"></i>
                  <p>服务内容</p>
                </div>
                <div class="item-right">
                  为中国企业提供“出海前、出海后” 一站式服务；如出海可行性报告、海外公司注册、海外当地接送机服务、海外当地办公场所租赁、海外当地员工招聘等一站式服务；
                </div>
              </div>
              <div class="normal-panel">
                仅办理“海外公司注册、海外银行公司开户、海外商标注册”等少数几项业务，“出海后”的当地企业服务，几乎不做；
              </div>
            </div>
            <div class="compare-item flex flex-between mb10">
              <div class="light-panel flex flex-start flex-middle">
                <div class="item-left">
                  <i class="icon-service-team"></i>
                  <p>服务团队</p>
                </div>
                <div class="item-right">
                  海那边在海外当地，配置本地化专业服务团队，专人专业做专项服务；
                </div>
              </div>
              <div class="normal-panel">
                无配置海外当地专业化本土服务团队，多以快递或邮件方式，不固定式的找海外当地代办公司办理；
              </div>
            </div>
            <div class="compare-item flex flex-between">
              <div class="light-panel flex flex-start flex-middle">
                <div class="item-left">
                  <i class="icon-risk-control"></i>
                  <p>风险把控</p>
                </div>
                <div class="item-right">
                  海那边把控服务全流程，专业的本地化团队、律师、税务等团队为客户杜绝风险；

                </div>
              </div>
              <div class="normal-panel">
                对海外业务办理质量不好把控，如挂名董事不配合签字、挂名董事捐钱跑路等等问题；
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="service-flow">
        <div class="rocess-title">
          <span>定制服务流程</span>
        </div>
        <img
          class="sever-rocess-img"
          src="../assets/images/sever-rocess.png"
        />
      </div>
      <div class="company-location">
        <div class="rocess-title">
          <span>海那边全球办公室</span>
        </div>
        <div class="office-desc">
          <img
            class="office-desc-maohao-left"
            src="../assets/images/maohao-left.png"
          />
          海那边
          <span>&nbsp;“出海企服”&nbsp;</span>服务新始，已在新加坡、马来西亚、泰国、韩国、埃及设置本地办公室专业服务团队；北美、欧洲、澳洲、非洲、亚洲其它国家地区办公室专业服务团队，紧张筹办中……
          <img
            class="office-desc-maohao-right"
            src="../assets/images/maohao-right.png"
          />
        </div>
      </div>
      <div class="contact-panel">
        <img src="../assets/images/contact_bg_01.png">
      </div>
      <div class="office-panel">
        <div class="office-top flex flex-start">
          <img src="../assets/images/office_01.png">
          <img src="../assets/images/office_02.png">
        </div>
        <div class="office-bottom flex flex-start">
          <img src="../assets/images/office_03.png">
          <img src="../assets/images/office_04.png">
          <img src="../assets/images/office_05.png">
        </div>
      </div>
      <div class="contact-panel-2">
        <img src="../assets/images/contact_bg_02.png">
      </div>
      <div class="office-world-panel">
        <div class="world-top flex flex-wrap">
          <div class="office-item mr14">
            <img src="../assets/images/world_01.png">
            <div class="office-name">新加坡办公室</div>
          </div>
          <div class="office-item">
            <img src="../assets/images/world_02.png">
            <div class="office-name">新加坡办公室</div>
          </div>
          <div class="office-item mr14">
            <img src="../assets/images/world_03.png">
            <div class="office-name">马来西亚（砂拉越）</div>
          </div>
          <div class="office-item">
            <img src="../assets/images/world_04.png">
            <div class="office-name">马来西亚（砂拉越）</div>
          </div>
        </div>
        <div class="world-bottom flex flex-between">
          <div class="bottom-left">
            <div class="office-item">
              <img src="../assets/images/world_05.png">
              <div class="office-name">韩国办公室</div>
            </div>
            <div class="office-item">
              <img src="../assets/images/world_06.png">
              <div class="office-name">韩国办公室</div>
            </div>
          </div>
          <div class="bottom-right">
            <div class="office-item">
              <img src="../assets/images/world_07.png">
              <div class="office-name">韩国办公室</div>
            </div>
          </div>
        </div>
      </div>
      <div class="company-logo">
        <img src="../assets/images/company_logo.png">
      </div>
    </div>
    <div class="footer-space"></div>
    <div class="footer">
      <div
        class="consult-button"
        @click="nextStep('country')"
      >免费咨询</div>
    </div>
    <van-popup
      v-model:show="showCountry"
      position="bottom"
      round
      class="country-popup-panel"
    >
      <div class="popup-panel">
        <p class="pop-title">选择您想了解的国家/城市</p>
        <div class="country-list flex flex-wrap">
          <div
            class="country-item"
            v-for="(item, index) in countryList"
            :key="index"
            :class="[countryIndex == index ? 'active' : '']"
            @click="setCountryIndex(index,item.location_name)"
          >
            {{ item.location_name }}
          </div>
        </div>
        <div class="popup-consult-panel">
          <div
            class="popup-button"
            :class="[countryIndex != -1 ? 'button-active' : '']"
            @click="nextStep('service')"
          >
            下一步
          </div>
        </div>
      </div>
    </van-popup>
    <van-popup
      v-model:show="showService"
      position="bottom"
      round
      class="service-popup-panel"
      v-if="countryList[countryIndex]"
    >
      <div class="popup-panel">
        <p class="pop-title">选择您需要的服务（可多选）</p>
        <div class="service-list">
          <div
            class="service-item flex flex-start"
            v-for="(item, index) in countryList[countryIndex].service"
            :key="index"
            :class="[serviceIndex.indexOf(index) > -1 ? 'active' : '']"
            @click="addServiceIndex(index)"
          >
            <div class="item-icon">
              <i
                v-if="serviceIndex.indexOf(index) > -1"
                class="icon-radio-selected"
              ></i>
              <span
                v-else
                class="icon-radio"
              ></span>
            </div>
            <div class="item-content">
              <p class="title">
                <span>{{ `${index + 1}.` }}</span>{{ item.service_name }}
              </p>
              <p class="sub-title">{{ item.service_content }}</p>
            </div>
          </div>
        </div>
        <div class="popup-consult-space"></div>
        <div class="popup-consult-panel">
          <div
            class="popup-button"
            :class="[serviceIndex.length>0 ? 'button-active' : '']"
            @click="nextStep('login')"
          >
            下一步
          </div>
        </div>
      </div>
    </van-popup>
    <van-popup
      v-model:show="showLogin"
      position="bottom"
      round
      class="login-popup-panel"
    >
      <div class="popup-panel">
        <p class="pop-title">请留下您的联系方式</p>
        <div class="form-item flex flex-between flex-middle mb38">
          <input
            type="text"
            placeholder="请输入公司名称（选填）"
            v-model="name"
          />
          <i
            v-if="name"
            class="icon-input-del"
            @click="name = ''"
          ></i>
        </div>
        <div class="form-item flex flex-between flex-middle mb38">
          <input
            type="tel"
            placeholder="请输入手机号码"
            v-model="phone"
            :style="{ color: phone ? '#333' : '#9DABC4' }"
            oninput="if(value.length > 11)value = value.slice(0, 11)"
            @blur="phoneBlur"
          />
          <i
            v-if="phone"
            class="icon-input-del"
            @click="phone = ''"
          ></i>
        </div>
        <div
          class="form-item flex flex-between flex-middle"
          :class="[errorTip ? '' : 'mb50']"
        >
          <input
            type="tel"
            v-model="vcode"
            placeholder="请输入验证码"
            :style="{ color: vcode ? '#333' : '#9DABC4' }"
            oninput="if(value.length > 6) value=value.slice(0, 6)"
            @blur="vcodeBlur"
          />
          <span
            class="vcode-button"
            :class="phone && sendVcode ? 'vcode-active' : ''"
            @click="getVcode"
          >{{ sendcodeTxt }}</span>
        </div>
        <p
          v-if="errorTip"
          class="error-tip"
        >{{ errorTip }}</p>
        <div class="popup-consult-panel">
          <div
            class="popup-button"
            :class="[phone && vcode ? 'button-active' : '']"
            @click="login"
          >
            免费咨询
          </div>
        </div>
      </div>
    </van-popup>
    <van-overlay
      :show="showConfirm"
      @click="showConfirm = false"
      z-index="1000"
    >
      <div
        class="overlay-panel"
        @click.stop
      >
        <div class="overlay-body">
          <img src="../assets/images/confirm_layer_header.png">
          <p class="title">预约成功</p>
          <p class="sub-title">资深专家会在24小时内联系您</p>
          <div
            class="confirm-button"
            @click="showConfirm = false"
          >
            我知道了
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>
<script>
import Utils from "../assets/js/Utils";
import Url from "../assets/js/Url";
import Share from "../assets/js/Share"
import { Toast, Overlay, Popup} from "vant";
export default {
  components: {
    [Toast.name]: Toast,
    [Overlay.name]: Overlay,
    [Popup.name]: Popup
  },
  data() {
    return {
      serviceType: 0,
      isShowAllItem: false,
      showLogin: false,
      showCountry: false,
      showService: false,
      showConfirm: false,
      name: "",
      phone: "",
      vcode: "",
      name: "",
      isPhone: false,
      isCode: false,
      errorTip: "",
      sendcodeTxt: "获取验证码",
      closeVcodeBool: false,
      closePhoneBool: false,
      isLogin: false,
      sendVcode: true, //控制验证码发送开关
      phoneRight: false,
      vcodeRight: false,
      headerImg: "",
      cid: "",
      agent_uuid: "",
      qr_code: "",
      aid: "10000",
      desc: "",
      buttonText: "",
      ip: "",
      bg_img: "",
      nation_num: 0,
      areaCode: "",
      isShowCountry: false,
      distance: 0,
      countryList: [],
      countryIndex: -1,
      serviceIndex: [],
      hasClickLogin:false,
    };
  },
  mounted() {
    let cid=this.$route.query.cid
    this.cid=cid?cid:''
    this.$report.selfPv({
      page_id: 2020
    });
    let shareData={
      title:'助力企业出海，做全球业务',
      desc:'想去海外开公司，怕语言不通，不了解当地行情，不知道从何开始……别让这些小事难住您，交给我们！',
      imgUrl:'',
      link: window.location.href,
    }
    this.getOverseaCountryList();
    Share.onShare({
      title: shareData.title, //分享朋友圈的title
      desc: shareData.desc, //分享到朋友圈的描述
      imgUrl: 'https://cdn.hinabian.com/20220518/b76777aa354151d20b05bb50474c0489.png',
      link: window.location.href
    });
  },
  methods: {
    setServiceType(index) {
      this.serviceType = index;
    },
    addServiceIndex(index) {
      let location = this.serviceIndex.indexOf(index);
      if (location > -1) {
        this.serviceIndex.splice(location, 1);
      } else {
        this.serviceIndex.push(index);
      }
      this.$report.click({
        click_id: 101,
        page_id: 203,
        attr: {
          content: this.getServiceAnswers()
        }
      });
    },
    setCountryIndex(index, name) {
      this.countryIndex = index;
      this.$report.click({
        click_id: 101,
        page_id: 202,
        attr: {
          content: name
        }
      });
    },
    getServiceAnswers() {
      let answers = `（1）、选择您想了解的国家/城市：\n${
        this.countryList[this.countryIndex].location_name
      }\n（2）、选择您需要的服务（可多选）：\n`;
      this.countryList[this.countryIndex].service.map((item, index) => {
        if (this.serviceIndex.indexOf(index) > -1) {
          answers += `${index + 1}、${item.service_name},${
            item.service_content
          }\n`;
        }
      });
      return answers;
    },
    nextStep(type) {
      switch (type) {
        case "country":
          this.countryIndex = -1;
          this.showCountry = true;
          this.$report.click({
            click_id: 101,
            page_id: 201
          });
          this.$report.selfPv({
            page_id: 2020
          });
          break;
        case "service":
          if (this.countryIndex == -1) {
            Toast.fail("选择您想了解的国家/城市");
            break;
          }
          this.serviceIndex = [];
          this.showCountry = false;
          this.showService = true;
          this.$report.selfPv({
            page_id: 203
          });
          break;
        case "login":
          if (this.serviceIndex.length == 0) {
            Toast.fail("请选择您需要的服务");
            break;
          }
          this.name = "";
          this.vcode = "";
          this.errorTip = "";
          this.sendVcode = true;
          this.showService = false;
          this.showLogin = true;

          break;
      }
    },
    getOverseaCountryList() {
      this.$http.get(Url.overseaCountry).then(res => {
        this.countryList = res;
      });
    },
    clear(model) {
      if (model == "phone") {
        this.phone = "";
      } else {
        this.vcode = "";
      }
    },
    //倒计时
    countDown: function() {
      if (this.time > 0) {
        this.time--;
        this.sendcodeTxt = `重新发送(${this.time})`;
        this.sendVcode = false; //禁止再次点击，发送验证码
        setTimeout(this.countDown, 1000);
      } else {
        this.time = 0;
        this.sendcodeTxt = "重获验证码";
        //倒计时结束，重新获取验证码可点
        this.sendVcode = true;
        this.vcodeDisable = false;
      }
    },
    //手机号码输入框失去焦点时,检查号码是否符合
    vcodeBlur: function() {
      //检测验证码格式是否正确
      if (Utils.chineseMobile(this.phone)) {
        if (Utils.checkVCode(this.vcode) && this.vcode != "") {
          this.vcodeRight = true;
          this.errorTip = "";
        } else {
          this.vcodeRight = false;
          //验证码为空时，错误提示为空
          if (this.vcode != "") {
            this.errorTip = "请输入正确验证码";
          }
        }
      } else {
        if (this.vcode != "") {
          this.errorTip = "请输入您的手机号";
        }
      }
    },
    //手机号码输入框失去焦点时,检查号码是否符合
    phoneBlur: function() {
      //检测是否为手机号码
      if (Utils.chineseMobile(this.phone) && this.phone != "") {
        this.sendVcode = true; //控制验证码发送开关
        this.phoneRight = true;
        this.errorTip = "";
        // alert(this.phone)
      } else {
        this.phoneRight = false;
        //手机号码为空时，错误提示为空
        if (this.phone != "") {
          this.errorTip = "请填写正确的手机号";
        }
      }
    },
    //获取验证码
    getVcode: function() {
      let _this = this;
      if (!this.sendVcode || this.phone.length == 0) {
        return false;
      }
      this.sendVcode = true;
      if (!Utils.chineseMobile(this.phone)) {
        this.errorTip = "请填写正确的手机号";
        return false;
      }
      this.$http
        .encryptRequest({
          url: Url.smsVcodeUrl,
          method: "post",
          data: {
            mobile: this.phone,
            hnbType: "yimin"
          }
        })
        .then(data => {
          Toast.success("验证码已发送");
        })
        .catch(error => {
          Toast.fail("验证码发送失败");
          _this.sendVcode = true; //禁止再次点击，发送验证码
        });
      this.time = 60;
      this.countDown();
      this.vcodeDisable = true;
      this.$report.click({
        click_id: 101,
        page_id: 204
      });
    },
    //登录提交
    login: function() {
      let _this = this;
      if(this.hasClickLogin){
        return false
      }
      this.hasClickLogin=true
      if (_this.phone == "" && _this.vcode == "") {
        return false;
      }
      if (_this.phone == "" || !Utils.chineseMobile(this.phone)) {
        this.errorTip = "请填写正确的手机号";
        //Toast.showNotice("请填写正确的手机号");
        return false;
      } else {
        this.errorTip = "";
      }
      if (this.vcode == "" || !Utils.checkVCode(this.vcode)) {
        this.errorTip = "请填写正确的验证码";
        //Toast.showNotice("请填写正确的验证码");
        return false;
      } else {
        this.errorTip = "";
      }
      let source = {
        source_ym: 80
      };
      if(_this.cid){
        source.cid=_this.cid
      }
      let answers = this.getServiceAnswers();
      let params = {
        mobile: _this.phone,
        vcode: _this.vcode,
        source: source,
        history: {
          type: 2,
          content: answers
        }
      };
      if (_this.name) {
        params.name = _this.name;
      }

      this.$http
        .encryptRequest({
          url: Url.loginMobile,
          method: "post",
          data: params
        })
        .then(res => {
          this.showLogin = false;
          this.hasClickLogin=false
          this.showConfirm = true;
        })
        .catch(error => {
          this.hasClickLogin=false
          this.errorTip = error.msg ? error.msg : error;
        });
      this.$report.click({
        click_id: 102,
        page_id: 204
      });
    }
  }
};
</script>
<style lang="less" scoped>

.van-popup {
  .popup-panel {
    position: relative;
    padding: 60px 30px 20px;
  }
  .pop-title {
    height: 52px;
    font-size: 38px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: #333333;
    line-height: 52px;
    text-align: center;
    margin-bottom: 45px;
  }
  .popup-consult-space{
    width: 100%;
    height: 148px;
  }
  .popup-consult-panel {
    position: fixed;
    bottom: 0;
    left: 0;
    width: calc(100% - 64px);
    padding: 20px 32px;
    height: 108px;
    background: #fff;
    .popup-button,
    .button-active {
      height: 88px;
      background: rgba(15, 79, 187, 0.2);
      border-radius: 44px;
      font-size: 32px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      line-height: 88px;
      text-align: center;
      margin: 0 auto;
    }
    .button-active {
      background: rgba(15, 79, 187, 1);
    }
  }
}
.country-popup-panel {
  height: 840px;
  .country-list {
    .country-item,
    .active {
      width: 320px;
      height: 96px;
      background: #f2f4f9;
      border-radius: 48px;
      font-size: 32px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      line-height: 96px;
      color: #9dabc4;
      text-align: center;
      margin-right: 40px;
      margin-bottom: 40px;
      &:nth-child(2n + 0) {
        margin-right: 0;
      }
    }
    .active {
      color: #ffffff;
      background: #0f4fbb;
    }
  }
}
.service-popup-panel {
  height: 1060px;
  .service-list {
    padding: 0 22px 0 36px;
    .service-item {
      margin-bottom: 30px;
      .item-icon {
        padding-top: 6px;
        width: 36px;
        text-align: center;
        margin-right: 15px;
        flex-shrink: 0;
      }
      .item-content {
        .title {
          height: 45px;
          font-size: 32px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          color: #333333;
          line-height: 45px;
          margin-bottom: 5px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1; //（行数）
          /*! autoprefixer: off */
          -webkit-box-orient: vertical;
          text-align: left;
          span {
            font-weight: 600;
            font-size: 32px;
            color: #333333;
            margin-right: 10px;
          }
        }
        .sub-title {
          font-size: 25px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #9dabc4;
          line-height: 36px;
          overflow: hidden;
          text-align: left;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2; //（行数）
          /*! autoprefixer: off */
          -webkit-box-orient: vertical;
          padding-left: 38px;
        }
      }
    }
    .icon-radio {
      display: inline-block;
      width: 28px;
      height: 28px;
      border: 3px solid #9dabc4;
      border-radius: 50%;
    }
    .icon-radio-selected {
      display: inline-block;
      width: 36px;
      height: 36px;
      background: url("../assets/images/icon_radio.png") no-repeat;
      background-size: contain;
    }
  }
}
.login-popup-panel {
  height: 730px;
  .popup-panel {
    .error-tip {
      padding-left: 32px;
      height: 32px;
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #d24f40;
      line-height: 32px;
      margin-top: 18px;
      margin-bottom: 46px;
      text-align: left;
    }
    .mb38 {
      margin-bottom: 38px;
    }
    .mb50 {
      margin-bottom: 50px;
    }
    .form-item {
      padding: 0 32px;
      height: 88px;
      background: #f2f4f9;
      border-radius: 44px;
      input {
        background: #f2f4f9;
        width: 80%;
        height: 42px;
        font-size: 30px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 42px;
        text-align: left;
        &::-webkit-input-placeholder {
          height: 42px;
          font-size: 30px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #9dabc4;
          line-height: 42px;
        }
      }
      .vcode-button,
      .vcode-active {
        width: 225px;
        height: 36px;
        font-size: 30px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #9dabc4;
        line-height: 36px;
      }
      .vcode-active {
        color: #0f4fbb;
      }
    }

    .icon-input-del {
      display: inline-block;
      width: 26px;
      height: 26px;
      background: url("../assets/images/icon_input_del.png") no-repeat;
      background-size: contain;
    }
  }
}
.wrap {
  min-height: 100vh;
  .header {
    img {
      width: 100%;
      height: 408px;
    }
  }
  .content {
    background: #0e0a1e;
    overflow: hidden;
  }
  .service-panel {
    padding: 0 30px;
    margin-bottom: 72px;
    .mb48 {
      margin-bottom: 48px;
    }
    position: relative;
    padding-top: 68px;
    .switch-panel {
      position: relative;
      margin:0 auto;
      width: 690px;
      min-height: 710px;
      border-radius: 10px;
      z-index: 10;
      overflow: hidden;
      .switch-header {
        overflow: hidden;
        background: #2550b2;
        .border-left{
          border-bottom-right-radius: 16px;
        }
        .border-right{
          border-bottom-left-radius: 16px;
        }
        .service-type {
          width: 50%;
          height: 34px;
          padding: 28px 0;
          font-size: 36px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #ffffff;
          line-height: 34px;
          background: #151f4a;
        }
        .active {
          font-weight: bold;
          color: #ffffff;
          line-height: 34px;
          background: #2550b2;
        }
      }
      .service-content {
        padding: 44px 20px;
        background: #2550b2;
        .service-item {
          width: 316px;
          margin-right: 18px;
          margin-bottom: 32px;
          &:nth-child(2n + 0) {
            margin-right: 0;
          }
          img {
            width: 316px;
            height: 188px;
            margin-bottom: 21px;
          }
          p {
            font-size: 24px;
            font-family: Source Han Sans CN;
            font-weight: 500;
            color: #ffffff;
            line-height: 32px;
          }
        }
      }
    }
    .space-bg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 434px;
      z-index: 1;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .contact-panel{
    width:700px;
    height: 591px;
    margin:0 auto 38px;
    img{
      width: 100%;
      height: 100%;
    }
  }
  .contact-panel-2{
    width:700px;
    height: 766px;
    margin:0 auto 30px;
    img{
      width: 100%;
      height: 100%;
    }
  }
  .office-world-panel{
    padding:0 30px;
    width: 694px;
    margin:0 auto;
    .mr14{
        margin-right: 14px;
      }
      .office-item{
        position: relative;
        .office-name{
          width: 100%;
          position: absolute;
          bottom: 0;
          left: 0;
          height: 42px;
          z-index: 10;
          background: rgba(4,19,79, .6);
          border-radius: 0px 0px 12px 12px;
          font-size: 24px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 42px;
          text-align: center;
        }
      }
    .world-top{
      .office-item{
        width: 338px;
        height: 232px;
        margin-bottom: 14px;
        img{
          width: 338px;
          height: 232px;
        }
      }
    }
    .world-bottom{
      .bottom-left{
        margin-right: 14px;
        .office-item{
          width: 338px;
          height: 232px;
          margin-bottom: 14px;
          img{
            width: 338px;
            height: 232px;
          }
        }
      }
      .bottom-right{
        .office-item{
          width: 340px;
          height: 478px;
          img{
            width: 340px;
            height: 478px;
          }
        }
      }
    }
  }
  .company-logo{
    width: 100%;
    height: 190px;
    img{
      width: 100%;
      height: 100%;
    }
  }
  .office-panel{
    max-width: 691px;
    padding:0 30px;
    margin:0 auto;
    margin-bottom: 52px;
    .office-top{
      margin-bottom: 16px;
      img{
        width: 338px;
        height: 220px;
        margin-right: 15px;
        &:last-child{
          margin-right: 0;
        }
      }
    }
    .office-bottom{
      img{
        width: 220px;
        height: 230px;
        margin-right: 16px;
        &:last-child{
          margin-right: 0;
        }
      }
    }
  }
  .overlay-panel {
    position: relative;
    width: 100%;
    height: 100%;
    .overlay-body {
      position: absolute;
      width: 360px;
      height: 344px;
      padding: 42px 20px 44px;
      background: #ffffff;
      border-radius: 50px;
      top: 50%;
      margin-top: -270px;
      left: 50%;
      margin-left: -200px;
      z-index: 100;
      text-align: center;
      img {
        width: 135px;
        height: 137px;
      }
      .title {
        height: 36px;
        font-size: 32px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #333333;
        line-height: 36px;
        margin-bottom: 10px;
      }
      .sub-title {
        height: 36px;
        font-size: 26px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #9dabc4;
        line-height: 36px;
        margin-bottom: 44px;
      }
      .confirm-button {
        width: 240px;
        height: 88px;
        background: #0f4fbb;
        border-radius: 50px;
        line-height: 88px;
        font-size: 32px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #f9f9f9;
        margin: auto;
        text-align: center;
      }
    }
  }
  .company-panel {
    padding: 0 30px;
    height: 100%;
    margin-bottom: 72px;
    .company-body {
      background: #151f4a;
      border-radius: 10px;
      padding: 44px 16px;
      .company-title {
        position: relative;
        height: 29px;
        font-size: 30px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #ffffff;
        line-height: 28px;
        text-align: center;
        &::before {
          position: absolute;
          left: 6px;
          top: 0;
          display: block;
          content: "";
          width: 9px;
          height: 26px;
          background: #f8c428;
        }
      }
      .company-bg {
        width: 318px;
        height: 68px;
        background: #1b69d0;
        border-radius: 34px;
        line-height: 68px;
        font-size: 36px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #ffffff;
        margin: 0 auto 36px;
      }
      .company-money {
        width: 550px;
        font-size: 26px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #ffffff;
        line-height: 40px;
        margin: 0 auto 28px;
      }
      .company-invest {
        width: 631px;
        padding: 16px 12px 22px;
        background: #fff;
        border-radius: 6px;
        margin:0 auto;
        margin-bottom: 20px;
        .invest-top {
          margin-bottom: 15px;
          img {
            width: 115px;
            height: 212px;
            margin-right: 14px;
            &:last-child {
              margin-right: 0;
            }
          }
        }
        .invest-bottom {
          img {
            width: 125px;
            height: 76px;
          }
        }
      }
      .service-compare {
        max-width: 658px;
        margin:auto;
        .mb10 {
          margin-bottom: 10px;
        }
        color: #fff;
        .light-panel {
          width: 416px;
          background: #2550b2;
          flex-shrink: 0;
        }
        .normal-panel {
          width: 242px;
          background: #182a6b;
          flex-shrink: 0;
        }
        .compare-title {
          border-radius: 6px;
          overflow: hidden;
          .light-panel {
            padding: 22px 0;
            text-align: center;
            font-size: 30px;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #ffffff;
            line-height: 30px;
          }
          .normal-panel {
            padding: 22px 0;
            font-size: 28px;
            text-align: center;
            font-family: Source Han Sans CN;
            font-weight: 600;
            color: rgba(255, 255, 255, 0.9);
            line-height: 28px;
          }
        }
        .compare-item {
          border-radius: 6px;
          overflow: hidden;
          .light-panel {
            width: 369px;
            padding: 22px 20px 22px 27px;
            font-size: 22px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #ffffff;
            line-height: 32px;
            .item-left {
              margin-right: 19px;
              width: 111px;
              flex-shrink: 0;
            }
            .item-right {
              width: 224px;
              font-size: 22px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #ffffff;
              line-height: 32px;
              text-align: left;
              flex-shrink: 0;
            }
          }
          .normal-panel {
            padding: 26px 14px 26px 26px;
            width: 202px;
            font-size: 22px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: rgba(255, 255, 255, 0.9);
            line-height: 32px;
            text-align: left;
          }
        }
      }
    }
    .mb66 {
      margin-bottom: 66px;
    }
  }
  .office-desc {
    position: relative;
    width: 493px;
    display: block;
    margin: 53px auto;
    font-size: 26px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #ffffff;
    line-height: 40px;
    text-align: left;
    span {
      font-size: 28px;
    }
    .office-desc-maohao-left {
      position: absolute;
      width: 42px;
      left: -58px;
      top: -10px;
    }
    .office-desc-maohao-right {
      display: inline-block;
      width: 42px;
      margin-left: 12px;
      // vertical-align: -webkit-baseline-middle;
      margin-top: 24px;
    }
  }
  .company-location{
    margin-bottom: 65px;
    .office-desc{
      width: 519px;
    }
  }

  .rocess-title {
    position: relative;
    margin: auto;
    display: table;
    span {
      position: relative;
      font-size: 52px;
      font-family: "uifamily";
      font-weight: 400;
      color: #ffffff;
      z-index: 2;
      line-height: 1;
    }
    &::after {
      content: "";
      position: absolute;
      width: 114px;
      height: 78px;
      left: -46px;
      top: 50%;
      transform: translateY(-50%);
      background: url(../assets/images/title-left.png) center center no-repeat;
      background-size: 100%;
      z-index: 1;
    }
    &::before {
      content: "";
      position: absolute;
      width: 41px;
      height: 29px;
      right: -38px;
      bottom: -5px;
      background: url(../assets/images/title-right.png) center center no-repeat;
      background-size: 100%;
      z-index: 1;
    }
  }
  .sever-rocess-img {
    display: block;
    width: 690px;
    height: auto;
    margin: 71px auto 101px;
  }
}
.more-button {
  width: 224px;
  height: 48px;
  border: 1px solid rgba(255, 255, 255, 0.8);
  border-radius: 24px;
  font-size: 24px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #ffffff;
  line-height: 48px;
  margin: auto;
  i {
    margin-left: 10px;
  }
}
.footer {
  position: fixed;
  bottom: 0;
  z-index: 110;
  left: 0;
  width: 100%;
  height: 108px;
  padding-top: 20px;
  background: #fff;
  overflow: hidden;
  .consult-button {
    width: 686px;
    height: 88px;
    background: #0f4fbb;
    border-radius: 44px;
    line-height: 88px;
    text-align: center;
    font-size: 32px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    margin: 0 auto;
  }
}
.icon-arrow-down {
  display: inline-block;
  width: 20px;
  height: 20px;
  background: url("../assets/images/icon_arrow_down.png") no-repeat;
  background-size: contain;
}
.icon-arrow-up {
  display: inline-block;
  width: 20px;
  height: 20px;
  background: url("../assets/images/icon_arrow_up.png") no-repeat;
  background-size: contain;
}
.icon-service-content {
  display: inline-block;
  width: 60px;
  height: 60px;
  background: url("../assets/images/icon_service_content.png") no-repeat;
  background-size: contain;
}
.icon-risk-control {
  display: inline-block;
  width: 60px;
  height: 60px;
  background: url("../assets/images/icon_risk_control.png") no-repeat;
  background-size: contain;
}
.icon-service-team {
  display: inline-block;
  width: 60px;
  height: 60px;
  background: url("../assets/images/icon_service_team.png") no-repeat;
  background-size: contain;
}
.footer-space {
  width: 100%;
  height: 128px;
  background: #0E0A1E;
}
</style>
